import { isMain } from '@/utils/tools'
// 测评详情页
let MeasurementDetails = () =>
  import( /* webpackChunkName: "group-measurement" */ '@/views/measurement/measurement_details/index')
// 邀请他评
let Evaluation = () =>
  import( /* webpackChunkName: "group-evaluation" */ '@/views/measurement/evaluation/index')
// 他评
let Evaluation_Name = () =>
  import( /* webpackChunkName: "group-evaluation_name" */ '@/views/measurement/evaluation_name/index')
// 完成他评
let Evaluation_Share = () =>
  import( /* webpackChunkName: "group-Evaluation_share" */ '@/views/measurement/evaluation_share/index')
// 职业发展健康度报告
let MeasurementReport = () =>
  import( /* webpackChunkName: "group-measurement_report" */ '@/views/measurement/measurement_report/index')
// 测评答题页面
let MeasurementIndex = () =>
  import( /* webpackChunkName: "group-measurement_index" */ '@/views/measurement/measurement/index')
// 单独推送答题
let MeasurementPublicIndex = () =>
  import( /* webpackChunkName: "group-measurement_index" */ '@/views/measurement/measurement_public/index')
// 职场可迁移报告（自评版）
let myWorkAbilityDetails = () =>
  import( /* webpackChunkName: "group-my_work_ability_details" */ '@/views/measurement/my_work_ability_details/index')

// 单独推送答题   --   p1
let MeasurementPublicIndexP1 = () =>
  import( /* webpackChunkName: "group-measurement_index" */ '@/views/measurement/measurement_public_p1/index')
// 职场可迁移报告（自评版）  --   p1
let myWorkAbilityDetailsP1 = () =>
  import( /* webpackChunkName: "group-my_work_ability_details" */ '@/views/measurement/my_work_ability_details_p1/index')
// 职业价值观测评
let ProfessionalMeasurement = () =>
  import( /* webpackChunkName: "group-professional_measurement" */ '@/views/measurement/professional_measurement/index')
// 职业价值观测评报告
let ProfessionalReport = () =>
  import( /* webpackChunkName: "group-professional_report" */ '@/views/measurement/professional_report/index')

// 自我分化
let Ceping47Report = () =>
  import( /* webpackChunkName: "group-ceping47_report" */ '@/views/measurement/ceping47_report/index')
// 自我分化问答
let Ceping47 = () =>
  import( /* webpackChunkName: "group-ceping47" */ '@/views/measurement/ceping47/index')

// 霍兰德报告
let Ceping51Report = () =>
  import( /* webpackChunkName: "group-ceping51_report" */ '@/views/measurement/ceping51_report/index')
// 霍兰德
let Ceping51 = () =>
  import( /* webpackChunkName: "group-ceping51" */ '@/views/measurement/ceping51/index')

// 从减肥看灵魂动物测评报告
let Ceping54Report = () =>
  import( /* webpackChunkName: "group-ceping54_report" */ '@/views/measurement/ceping54_report/index')
// 从减肥看灵魂动物测评
let Ceping54 = () =>
  import( /* webpackChunkName: "group-ceping54" */ '@/views/measurement/ceping54/index')

// 产品经理胜任能力测评
let Ceping56 = () =>
  import( /* webpackChunkName: "group-ceping56" */ '@/views/measurement/ceping56/index')

// 产品经理胜任能力自测
let Ceping57 = () =>
  import( /* webpackChunkName: "group-ceping57" */ '@/views/measurement/ceping57/index')
// 产品经理胜任能力自测报告
let Ceping57Report = () =>
  import( /* webpackChunkName: "group-ceping57_report" */ '@/views/measurement/ceping57_report/index')

// 生涯信念测评详情
let Ceping55Details = () =>
  import( /* webpackChunkName: "group-ceping55_details" */ '@/views/measurement/ceping55_details/index')
// 生涯信念测评
let Ceping55 = () =>
  import( /* webpackChunkName: "group-ceping55" */ '@/views/measurement/ceping55/index')
// 生涯信念测评详情报告
let Ceping55Report = () =>
  import( /* webpackChunkName: "group-ceping55_report" */ '@/views/measurement/ceping55_report/index')

// 能力热力图测评
let Ceping59 = () =>
  import( /* webpackChunkName: "group-ceping59" */ '@/views/measurement/ceping59/index')
// 能力热力图测评报告
let Ceping59Report = () =>
  import( /* webpackChunkName: "group-ceping59_report" */ '@/views/measurement/ceping59_report/index')

// 霍兰德测评
let Ceping61 = () =>
  import( /* webpackChunkName: "group-ceping61" */ '@/views/measurement/ceping61/index')
// 霍兰德测评报告
let Ceping61Report = () =>
  import( /* webpackChunkName: "group-ceping61_report" */ '@/views/measurement/ceping61_report/index')

// 工作家庭平衡状态测评详情页
let Ceping62Details = () =>
  import( /* webpackChunkName: "group-ceping62_details" */ '@/views/measurement/ceping62_details/index')
// 工作家庭平衡状态测评
let Ceping62 = () =>
  import( /* webpackChunkName: "group-ceping62" */ '@/views/measurement/ceping62/index')
// 工作家庭平衡状态测评报告
let Ceping62Report = () =>
  import( /* webpackChunkName: "group-ceping62_report" */ '@/views/measurement/ceping62_report/index')

// 职业价值观测评
let Ceping63 = () =>
  import( /* webpackChunkName: "group-ceping63" */ '@/views/measurement/ceping63/index')
// 职业价值观报告
let Ceping63Report = () =>
  import( /* webpackChunkName: "group-ceping63_report" */ '@/views/measurement/ceping63_report/index')

// 价值观测评
let Ceping64 = () =>
  import( /* webpackChunkName: "group-ceping64" */ '@/views/measurement/ceping64/index')
// 价值观测评报告
let Ceping64Report = () =>
  import( /* webpackChunkName: "group-ceping64_report" */ '@/views/measurement/ceping64_report/index')

// 价值观测评
let Ceping110 = () =>
    import( /* webpackChunkName: "group-ceping110" */ '@/views/measurement/ceping110/index')
// 价值观测评报告
let Ceping110Report = () =>
    import( /* webpackChunkName: "group-ceping110_report" */ '@/views/measurement/ceping110_report/index')

// 能力热力图测评
let Ceping65 = () =>
  import( /* webpackChunkName: "group-ceping65" */ '@/views/measurement/ceping65/index')
// 能力热力图测评报告
let Ceping65Report = () =>
  import( /* webpackChunkName: "group-ceping65_report" */ '@/views/measurement/ceping65_report/index')

// 能力热力图测评
let Ceping112 = () =>
    import( /* webpackChunkName: "group-ceping112" */ '@/views/measurement/ceping112/index')
// 能力热力图测评报告
let Ceping112Report = () =>
    import( /* webpackChunkName: "group-ceping112_report" */ '@/views/measurement/ceping112_report/index')

// 职业定向测评
let Ceping67 = () =>
  import( /* webpackChunkName: "group-ceping67" */ '@/views/measurement/ceping67/index')
// 职业定向测评报告
let Ceping67Report = () =>
  import( /* webpackChunkName: "group-ceping67_report" */ '@/views/measurement/ceping67_report/index')

// 职业定向测评
let Ceping111 = () =>
    import( /* webpackChunkName: "group-ceping111" */ '@/views/measurement/ceping111/index')
// 职业定向测评报告
let Ceping111Report = () =>
    import( /* webpackChunkName: "group-ceping111_report" */ '@/views/measurement/ceping111_report/index')

// 职业定向测评
let Ceping95 = () =>
  import( /* webpackChunkName: "group-ceping95" */ '@/views/measurement/ceping95/index')
// 职业定向测评报告
let Ceping95Report = () =>
  import( /* webpackChunkName: "group-ceping95_report" */ '@/views/measurement/ceping95_report/index')

// 测评列表
let MeasurementList = () =>
  import( /* webpackChunkName: "group-measurement_list" */ '@/views/measurement/measurement_list/index')

// 测评模板
let Ceping = () =>
  import( /* webpackChunkName: "group-ceping" */ '@/views/measurement/ceping/index')
// 测评报告模板
let CepingReport = () =>
  import( /* webpackChunkName: "group-ceping62_report" */ '@/views/measurement/ceping_report/index')
// 测评画图
let Drawing = () =>
  import( /* webpackChunkName: "group-my_course" */ '@/views/measurement_drawing/drawing')

// ceping67 职业定向答题组件
let AnswerQuestions2 = () =>
  import( /* webpackChunkName: "group-answer-questions2" */ '@c/measurement/answer-questions2')
// ceping111 职业定向答题组件
let AnswerQuestions111 = () =>
    import( /* webpackChunkName: "group-answer-questions2" */ '@c/measurement/answer-questions111')

// ceping67 职业定向答题组件
let AnswerQuestions3 = () =>
  import( /* webpackChunkName: "group-answer-questions3" */ '@c/measurement/answer-questions3')

// ceping67 职业定向答题组件
let AnswerQuestions4 = () =>
  import( /* webpackChunkName: "group-answer-questions4" */ '@c/measurement/answer-questions4')

// 能力探索卡片
let Ceping68 = () =>
  import( /* webpackChunkName: "group-ceping68" */ '@/views/measurement/ceping68/index')

// 能力探索卡片报告
let Ceping68Report = () =>
  import( /* webpackChunkName: "group-ceping68_report" */ '@/views/measurement/ceping68_report/index')

// 选对
let XuanDui65 = () =>
  import( /* webpackChunkName: "group-xuandui65" */ '@/views/measurement/xuandui65/index')

// 选对报告
let XuanDui65Report = () =>
  import( /* webpackChunkName: "group-xuandui65_report" */ '@/views/measurement/xuandui65_report/index')


// 能力热力图测评（自评版）
let Test65 = () =>
  import( /* webpackChunkName: "group-test65" */ '@/views/measurement/test65/index')
// 能力热力图测评报告（自评版）
let Test65Report = () =>
  import( /* webpackChunkName: "group-test65_report" */ '@/views/measurement/test65_report/index')

// 能力热力图测评（ACCA版）
let Acca65 = () =>
  import( /* webpackChunkName: "group-acca65" */ '@/views/measurement/acca65/index')
// 能力热力图测评报告（ACCA版）
let Acca65Report = () =>
  import( /* webpackChunkName: "group-acca65_report" */ '@/views/measurement/acca65_report/index')

// 大学生兴趣测评
let Ceping69 = () =>
  import( /* webpackChunkName: "group-ceping69" */ '@/views/measurement/ceping69/index')
// 大学生兴趣测评报告
let Ceping69Report = () =>
  import( /* webpackChunkName: "group-ceping69_report" */ '@/views/measurement/ceping69_report/index')

// 馒头版测评
let Ceping70 = () =>
  import( /* webpackChunkName: "group-ceping70" */ '@/views/measurement/ceping70/index')
// 馒头版测评报告
let Ceping70Report = () =>
  import( /* webpackChunkName: "group-ceping70_report" */ '@/views/measurement/ceping70_report/index')
// 馒头版测评详情
let Ceping70Details = () =>
  import( /* webpackChunkName: "group-ceping70_details" */ '@/views/measurement/ceping70_details/index')

/**
 * ====复制测评
 */
// 价值观测评
let BdCeping64 = () =>
  import( /* webpackChunkName: "group-ceping64" */ '@/views/measurement/bd_ceping64/index')
// 价值观测评报告
let BdCeping64Report = () =>
  import( /* webpackChunkName: "group-ceping64_report" */ '@/views/measurement/bd_ceping64_report/index')

// 能力热力图测评
let BdCeping65 = () =>
  import( /* webpackChunkName: "group-ceping65" */ '@/views/measurement/bd_ceping65/index')
// 能力热力图测评报告
let BdCeping65Report = () =>
  import( /* webpackChunkName: "group-ceping65_report" */ '@/views/measurement/bd_ceping65_report/index')
// 职业定向测评
let BdCeping67 = () =>
  import( /* webpackChunkName: "group-ceping67" */ '@/views/measurement/bd_ceping67/index')
// 职业定向测评报告
let BdCeping67Report = () =>
  import( /* webpackChunkName: "group-ceping67_report" */ '@/views/measurement/bd_ceping67_report/index')

/**
 * 复制x计划的测评
 * 
 */
// 复制X测评
let Ceping71 = () =>
  import( /* webpackChunkName: "group-ceping71" */ '@/views/measurement/ceping71/index')
// 复制X测评测评报告
let Ceping71Report = () =>
  import( /* webpackChunkName: "group-ceping71_report" */ '@/views/measurement/ceping71_report/index')
// 复制X测评测评详情
let Ceping71Details = () =>
  import( /* webpackChunkName: "group-ceping71_details" */ '@/views/measurement/ceping71_details/index')

/**
 * 复制x计划的测评
 *
 */
// 复制X测评
let Ceping105 = () =>
    import( /* webpackChunkName: "group-ceping105" */ '@/views/measurement/ceping105/index')
// 复制X测评测评报告
let Ceping105Report = () =>
    import( /* webpackChunkName: "group-ceping105_report" */ '@/views/measurement/ceping105_report/index')
// 复制X测评测评详情
let Ceping105Details = () =>
    import( /* webpackChunkName: "group-ceping105_details" */ '@/views/measurement/ceping105_details/index')


// 复制X测评
let Ceping96 = () =>
  import( /* webpackChunkName: "group-ceping96" */ '@/views/measurement/ceping96/index')
// 复制X测评测评报告
let Ceping96Report = () =>
  import( /* webpackChunkName: "group-ceping96_report" */ '@/views/measurement/ceping96_report/index')
// 复制X测评测评详情
let Ceping96Details = () =>
  import( /* webpackChunkName: "group-ceping96_details" */ '@/views/measurement/ceping96_details/index')


/**
 * ====生涯定位测评
 */
// 价值观测评
let Ceping72 = () =>
  import( /* webpackChunkName: "group-ceping72" */ '@/views/measurement/ceping72/index')
// 价值观测评报告
let Ceping72Report = () =>
  import( /* webpackChunkName: "group-ceping72_report" */ '@/views/measurement/ceping72_report/index')
  // 价值观测评报告分享
let Ceping72Evaluation = () =>
  import( /* webpackChunkName: "group-ceping72_evaluation" */ '@/views/measurement/ceping72_evaluation/index')

/**
 * ====霍兰德职业倾向测评
 */
// 
let Ceping73 = () =>
  import( /* webpackChunkName: "group-ceping73" */ '@/views/measurement/ceping73/index')
// 
let Ceping73Report = () =>
  import( /* webpackChunkName: "group-ceping73_report" */ '@/views/measurement/ceping73_report/index')
// 
let Ceping73Details = () =>
  import( /* webpackChunkName: "group-ceping73_details" */ '@/views/measurement/ceping73_details/index')

let Ceping98 = () =>
  import( /* webpackChunkName: "group-ceping98" */ '@/views/measurement/ceping98/index')
// 
let Ceping98Report = () =>
  import( /* webpackChunkName: "group-ceping98_report" */ '@/views/measurement/ceping98_report/index')
// 
let Ceping98Details = () =>
  import( /* webpackChunkName: "group-ceping98_details" */ '@/views/measurement/ceping98_details/index')

let Ceping99 = () =>
  import( /* webpackChunkName: "group-ceping99" */ '@/views/measurement/ceping99/index')
// 
let Ceping99Report = () =>
  import( /* webpackChunkName: "group-ceping99_report" */ '@/views/measurement/ceping99_report/index')
// 
let Ceping99Details = () =>
  import( /* webpackChunkName: "group-ceping99_details" */ '@/views/measurement/ceping99_details/index')


let Ceping47Details = () =>
  import( /* webpackChunkName: "group-ceping47_details" */ '@/views/measurement/ceping47_details/index')

let measurementPublicDetails = () =>
  import( /* webpackChunkName: "group-measurement_public_details" */ '@/views/measurement/measurement_public_details/index')

let measurementPublicP1Details = () =>
  import( /* webpackChunkName: "group-measurement_public_p1_details" */ '@/views/measurement/measurement_public_p1_details/index')
let Ceping54Details = () =>
  import( /* webpackChunkName: "group-ceping54_details" */ '@/views/measurement/ceping54_details/index')
/**
 * 新瘦身测评
 * 
 */
// 从减肥看灵魂动物测评报告
let Ceping74Report = () =>
  import( /* webpackChunkName: "group-ceping74_report" */ '@/views/measurement/ceping74_report/index')
// 从减肥看灵魂动物测评
let Ceping74 = () =>
  import( /* webpackChunkName: "group-ceping74" */ '@/views/measurement/ceping74/index')
let Ceping74Details = () =>
  import( /* webpackChunkName: "group-ceping74_details" */ '@/views/measurement/ceping74_details/index')


/**\
 * 馒头新版
 * 
 */
// 霍兰德测评
let Ceping75 = () =>
  import( /* webpackChunkName: "group-ceping75" */ '@/views/measurement/ceping75/index')
// 霍兰德测评报告
let Ceping75Report = () =>
  import( /* webpackChunkName: "group-ceping75_report" */ '@/views/measurement/ceping75_report/index')


// BD复制大学生兴趣测评
let BdCeping69 = () =>
  import( /* webpackChunkName: "group-bd_ceping69" */ '@/views/measurement/bd_ceping69/index')
// 大学生兴趣测评报告
let BdCeping69Report = () =>
  import( /* webpackChunkName: "group-bd_ceping69_report" */ '@/views/measurement/bd_ceping69_report/index')

/**
 * 可迁移能力测评（学生版）
 * 
 */
// 可迁移能力测评（学生版）报告
let Ceping76Report = () =>
  import( /* webpackChunkName: "group-ceping76_report" */ '@/views/measurement/ceping76_report/index')
// 可迁移能力测评（学生版）
let Ceping76 = () =>
  import( /* webpackChunkName: "group-ceping76" */ '@/views/measurement/ceping76/index')
let Ceping76Details = () =>
  import( /* webpackChunkName: "group-ceping76_details" */ '@/views/measurement/ceping76_details/index')

/**
 * 推广复制ceoing71
 */
// 测评
let Zycp = () =>
  import( /* webpackChunkName: "group-zycp" */ '@/views/measurement/zycp/index')
// 测评测评报告
let ZycpReport = () =>
  import( /* webpackChunkName: "group-zycp_report" */ '@/views/measurement/zycp_report/index')

/**
 * 
 * 纯净版
 * 
 */
// 复制X测评
let Test71 = () =>
  import( /* webpackChunkName: "group-test71" */ '@/views/measurement/test71/index')
// 复制X测评测评报告
let Test71Report = () =>
  import( /* webpackChunkName: "group-test71_report" */ '@/views/measurement/test71_report/index')
// 复制X测评测评详情
let Test71Details = () =>
  import( /* webpackChunkName: "group-test71_details" */ '@/views/measurement/test71_details/index')

// 职场可迁移报告   --   p1
let Test52 = () =>
  import( /* webpackChunkName: "group-test52" */ '@/views/measurement/test52/index')
// 职场可迁移报告（自评版）  --   p1
let Test52Report = () =>
  import( /* webpackChunkName: "group-test52_report" */ '@/views/measurement/test52_report/index')
// 职场可迁移报告
let Test52Details = () =>
  import( /* webpackChunkName: "group-test52_details" */ '@/views/measurement/test52_details/index')
/**
 * ====霍兰德职业倾向测评
 */
// 
let Test73 = () =>
  import( /* webpackChunkName: "group-test73" */ '@/views/measurement/test73/index')
// 
let Test73Report = () =>
  import( /* webpackChunkName: "group-test73_report" */ '@/views/measurement/test73_report/index')
// 
let Test73Details = () =>
  import( /* webpackChunkName: "group-test73_details" */ '@/views/measurement/test73_details/index')
/**
 * 
 * ====纯净版===  end
 * 
 */
/**
 * ====霍兰德职业倾向测评---新航道
 */
// 
let Ceping78 = () =>
  import( /* webpackChunkName: "group-ceping78" */ '@/views/measurement/ceping78/index')
// 
let Ceping78Report = () =>
  import( /* webpackChunkName: "group-ceping78_report" */ '@/views/measurement/ceping78_report/index')
// 
let Ceping78Details = () =>
  import( /* webpackChunkName: "group-ceping78_details" */ '@/views/measurement/ceping78_details/index')

// 
let Ceping84 = () =>
  import( /* webpackChunkName: "group-ceping84" */ '@/views/measurement/ceping84/index')
// 
let Ceping84Report = () =>
  import( /* webpackChunkName: "group-ceping84_report" */ '@/views/measurement/ceping84_report/index')
// 
let Ceping84Details = () =>
  import( /* webpackChunkName: "group-ceping84_details" */ '@/views/measurement/ceping84_details/index')

// 
let Ceping97 = () =>
  import( /* webpackChunkName: "group-ceping97" */ '@/views/measurement/ceping97/index')
// 
let Ceping97Report = () =>
  import( /* webpackChunkName: "group-ceping97_report" */ '@/views/measurement/ceping97_report/index')
// 
let Ceping97Details = () =>
  import( /* webpackChunkName: "group-ceping97_details" */ '@/views/measurement/ceping97_details/index')

// 
let Ceping85 = () =>
  import( /* webpackChunkName: "group-ceping85" */ '@/views/measurement/ceping85/index')
// 
let Ceping85Report = () =>
  import( /* webpackChunkName: "group-ceping85_report" */ '@/views/measurement/ceping85_report/index')
// 
let Ceping85Details = () =>
  import( /* webpackChunkName: "group-ceping85_details" */ '@/views/measurement/ceping85_details/index')

// 
let Ceping86 = () =>
  import( /* webpackChunkName: "group-ceping86" */ '@/views/measurement/ceping86/index')
// 
let Ceping86Report = () =>
  import( /* webpackChunkName: "group-ceping86_report" */ '@/views/measurement/ceping86_report/index')
// 
let Ceping86Details = () =>
  import( /* webpackChunkName: "group-ceping86_details" */ '@/views/measurement/ceping86_details/index')

//
let Ceping106 = () =>
    import( /* webpackChunkName: "group-ceping106" */ '@/views/measurement/ceping106/index')
//
let Ceping106Report = () =>
    import( /* webpackChunkName: "group-ceping106_report" */ '@/views/measurement/ceping106_report/index')
//
let Ceping106Details = () =>
    import( /* webpackChunkName: "group-ceping106_details" */ '@/views/measurement/ceping106_details/index')

//
let Ceping107 = () =>
    import( /* webpackChunkName: "group-ceping107" */ '@/views/measurement/ceping107/index')
//
let Ceping107Report = () =>
    import( /* webpackChunkName: "group-ceping107_report" */ '@/views/measurement/ceping107_report/index')
//
let Ceping107Details = () =>
    import( /* webpackChunkName: "group-ceping107_details" */ '@/views/measurement/ceping107_details/index')

//
let Ceping108 = () =>
    import( /* webpackChunkName: "group-ceping108" */ '@/views/measurement/ceping108/index')
//
let Ceping108Report = () =>
    import( /* webpackChunkName: "group-ceping108_report" */ '@/views/measurement/ceping108_report/index')
//
let Ceping108Details = () =>
    import( /* webpackChunkName: "group-ceping108_details" */ '@/views/measurement/ceping108_details/index')

//
let Ceping109 = () =>
    import( /* webpackChunkName: "group-ceping109" */ '@/views/measurement/ceping109/index')
//
let Ceping109Report = () =>
    import( /* webpackChunkName: "group-ceping109_report" */ '@/views/measurement/ceping109_report/index')
//
let Ceping109Details = () =>
    import( /* webpackChunkName: "group-ceping109_details" */ '@/views/measurement/ceping109_details/index')


// 
let Ceping87 = () =>
  import( /* webpackChunkName: "group-ceping87" */ '@/views/measurement/ceping87/index')
// 
let Ceping87Report = () =>
  import( /* webpackChunkName: "group-ceping87_report" */ '@/views/measurement/ceping87_report/index')
// 
let Ceping87Details = () =>
  import( /* webpackChunkName: "group-ceping87_details" */ '@/views/measurement/ceping87_details/index')

// 
let Ceping88 = () =>
  import( /* webpackChunkName: "group-ceping88" */ '@/views/measurement/ceping88/index')
// 
let Ceping88Report = () =>
  import( /* webpackChunkName: "group-ceping88_report" */ '@/views/measurement/ceping88_report/index')
// 
let Ceping88Details = () =>
  import( /* webpackChunkName: "group-ceping88_details" */ '@/views/measurement/ceping88_details/index')

// 
let Ceping89 = () =>
  import( /* webpackChunkName: "group-ceping89" */ '@/views/measurement/ceping89/index')
// 
let Ceping89Report = () =>
  import( /* webpackChunkName: "group-ceping89_report" */ '@/views/measurement/ceping89_report/index')
// 
let Ceping89Details = () =>
  import( /* webpackChunkName: "group-ceping89_details" */ '@/views/measurement/ceping89_details/index')

// 
let Ceping90 = () =>
  import( /* webpackChunkName: "group-ceping90" */ '@/views/measurement/ceping90/index')
// 
let Ceping90Report = () =>
  import( /* webpackChunkName: "group-ceping90_report" */ '@/views/measurement/ceping90_report/index')
// 
let Ceping90Details = () =>
  import( /* webpackChunkName: "group-ceping90_details" */ '@/views/measurement/ceping90_details/index')

// 
let Ceping91 = () =>
  import( /* webpackChunkName: "group-ceping91" */ '@/views/measurement/ceping91/index')
// 
let Ceping91Report = () =>
  import( /* webpackChunkName: "group-ceping91_report" */ '@/views/measurement/ceping91_report/index')
// 
let Ceping91Details = () =>
  import( /* webpackChunkName: "group-ceping91_details" */ '@/views/measurement/ceping91_details/index')

// 
let Ceping92 = () =>
  import( /* webpackChunkName: "group-ceping92" */ '@/views/measurement/ceping92/index')
// 
let Ceping92Report = () =>
  import( /* webpackChunkName: "group-ceping92_report" */ '@/views/measurement/ceping92_report/index')
// 
let Ceping92Details = () =>
  import( /* webpackChunkName: "group-ceping92_details" */ '@/views/measurement/ceping92_details/index')

// 
let Ceping93 = () =>
  import( /* webpackChunkName: "group-ceping93" */ '@/views/measurement/ceping93/index')
// 
let Ceping93Report = () =>
  import( /* webpackChunkName: "group-ceping93_report" */ '@/views/measurement/ceping93_report/index')
// 
let Ceping93Details = () =>
  import( /* webpackChunkName: "group-ceping93_details" */ '@/views/measurement/ceping93_details/index')

// 
let Ceping94 = () =>
  import( /* webpackChunkName: "group-ceping94" */ '@/views/measurement/ceping94/index')
// 
let Ceping94Report = () =>
  import( /* webpackChunkName: "group-ceping94_report" */ '@/views/measurement/ceping94_report/index')
// 
let Ceping94Details = () =>
  import( /* webpackChunkName: "group-ceping94_details" */ '@/views/measurement/ceping94_details/index')

// 
// 2020双十一活动页面（你是哪种购物星人）-答题页
let Ceping79 = () => import( /* webpackChunkName: "group-ceping79" */ '@/views/measurement/ceping79/index')
// 2020双十一活动页面（你是哪种购物星人）-报告页
let Ceping79Report = () => import( /* webpackChunkName: "group-ceping79_report" */ '@/views/measurement/ceping79_report/index');
// 2020双十一活动页面（你是哪种购物星人）-详情页
let Ceping79Details = () => import( /* webpackChunkName: "group-ceping79_details" */ '@/views/measurement/ceping79_details/index')


/**
 * 
 * 复制测评==不需要登录
 * 
 */
// -答题页
let SaleCeping73 = () => import( /* webpackChunkName: "group-sale_ceping73" */ '@/views/measurement/sale_ceping73/index')
// -报告页
let SaleCeping73Report = () => import( /* webpackChunkName: "group-sale_ceping73_report" */ '@/views/measurement/sale_ceping73_report/index');
// -详情页
let SaleCeping73Details = () => import( /* webpackChunkName: "group-sale_ceping73_details" */ '@/views/measurement/sale_ceping73_details/index')



/**
 * ====价值观测评--新版
 */
// 
let Ceping46 = () =>
  import( /* webpackChunkName: "group-ceping46" */ '@/views/measurement/ceping46/index')
// 
let Ceping46Report = () =>
  import( /* webpackChunkName: "group-ceping46_report" */ '@/views/measurement/ceping46_report/index')
// 
let Ceping46Details = () =>
  import( /* webpackChunkName: "group-ceping46_details" */ '@/views/measurement/ceping46_details/index')

/**
 * ====登岛活动测评
 */
// 
// let Ceping80 = () => import( /* webpackChunkName: "group-ceping80" */ '@/views/measurement/ceping80/index')
// // 
// let Ceping80Report = () => import( /* webpackChunkName: "group-ceping80_report" */ '@/views/measurement/ceping80_report/index')
// 
let Ceping80 = () => import( /* webpackChunkName: "group-ceping80" */ '@/views/measurement/ceping80/index')
let Ceping80ActivityRules = () => import( /* webpackChunkName: "group-ceping80_activity_rules" */ '@/views/measurement/ceping80_activity_rules/index')
let Ceping80Report = () => import( /* webpackChunkName: "group-ceping80_report" */ '@/views/measurement/ceping80_report/index')
let ceping80Follow = () => import( /* webpackChunkName: "group-ceping80_follow" */ '@/views/measurement/ceping80_follow/index')
let ceping80Clover = () => import( /* webpackChunkName: "group-ceping80_clover" */ '@/views/measurement/ceping80_clover/index')
/**
 * ====做自己节测评
 */
// 
let Ceping81 = () => import( /* webpackChunkName: "group-ceping81" */ '@/views/measurement/ceping81/index')
// // 
let Ceping81Rank = () => import( /* webpackChunkName: "group-ceping81_rank" */ '@/views/measurement/ceping81_rank/index')
let Ceping81Poster = () => import( /* webpackChunkName: "group-ceping81_poster" */ '@/views/measurement/ceping81_poster/index')
/**
 * 
 * 一封信测评
 * 
 */
let Ceping82 = () => import( /* webpackChunkName: "group-ceping82" */ '@/views/measurement/ceping82/index')
let Ceping82Call = () => import( /* webpackChunkName: "group-ceping82" */ '@/views/measurement/ceping82_call/index')
let Ceping82Blessing = () => import( /* webpackChunkName: "group-ceping82" */ '@/views/measurement/ceping82_blessing/index')
let Ceping82question = () => import( /* webpackChunkName: "group-ceping82" */ '@/views/measurement/ceping82_question/index')
let ceping82BookList = () => import( /* webpackChunkName: "group-ceping82" */ '@/views/measurement/ceping82_bookList/index')
let ceping82Mail = () => import( /* webpackChunkName: "group-ceping82" */ '@/views/measurement/ceping82_mail/index')


// 职业现状测评
let Ceping83 = () =>
  import( /* webpackChunkName: "group-ceping83" */ '@/views/measurement/ceping83/index')
// 复制X测评测评报告
let Ceping83Report = () =>
  import( /* webpackChunkName: "group-ceping83_report" */ '@/views/measurement/ceping83_report/index')
// 复制X测评测评详情
let Ceping83Details = () =>
  import( /* webpackChunkName: "group-ceping83_details" */ '@/views/measurement/ceping83_details/index')

// 测评模板
let ExtCeping = () =>
  import( /* webpackChunkName: "group-ext_ceping" */ '@/views/ext/ceping/index')
// 测评报告模板
let ExtCepingReport = () =>
  import( /* webpackChunkName: "group-ext_ceping_report" */ '@/views/ext/ceping_report/index')


// 价值观测评
let Ceping100 = () =>
  import( /* webpackChunkName: "group-ceping100" */ '@/views/measurement/ceping100/index')
// 价值观测评报告
let Ceping100Report = () =>
  import( /* webpackChunkName: "group-ceping100_report" */ '@/views/measurement/ceping100_report/index')

// 能力热力图测评
let Ceping101 = () =>
  import( /* webpackChunkName: "group-ceping101" */ '@/views/measurement/ceping101/index')
// 能力热力图测评报告
let Ceping101Report = () =>
  import( /* webpackChunkName: "group-ceping101_report" */ '@/views/measurement/ceping101_report/index')
// 职业定向测评
let Ceping103 = () =>
  import( /* webpackChunkName: "group-ceping103" */ '@/views/measurement/ceping103/index')
// 职业定向测评报告
let Ceping103Report = () =>
  import( /* webpackChunkName: "group-ceping103_report" */ '@/views/measurement/ceping103_report/index')

// 大学生兴趣测评
let Ceping104 = () =>
  import( /* webpackChunkName: "group-ceping104" */ '@/views/measurement/ceping104/index')
// 大学生兴趣测评报告
let Ceping104Report = () =>
  import( /* webpackChunkName: "group-ceping104_report" */ '@/views/measurement/ceping104_report/index')

// 113
let Ceping113 = () =>
  import( /* webpackChunkName: "group-ceping113" */ '@/views/measurement/ceping113/index')
// 113测评报告
let Ceping113Report = () =>
  import( /* webpackChunkName: "group-ceping113_report" */ '@/views/measurement/ceping113_report/index')

// 114
let Ceping114 = () =>
  import( /* webpackChunkName: "group-ceping114" */ '@/views/measurement/ceping114/index')
// 114测评报告
let Ceping114Report = () =>
  import( /* webpackChunkName: "group-ceping114_report" */ '@/views/measurement/ceping114_report/index')


// ------------------------------------------------------------
// 上线判断

if (!isMain()) {

}


export default [
  {
    path: '/measurement_details', //
    name: '职业发展健康指数测评',
    component: MeasurementDetails
  },
  {
    path: '/measurement_report', //
    name: '职业发展健康指数测评',
    component: MeasurementReport
  },
  {
    path: '/measurement', //
    name: '职业发展健康指数测评',
    component: MeasurementIndex
  },
  {
    path: '/measurement_public', //
    name: '职场可迁移能力测评',
    component: MeasurementPublicIndex
  },
  {
    path: '/measurement_public_p1', //
    name: '职场可迁移能力测评',
    component: MeasurementPublicIndexP1
  },
  {
    path: '/professional_measurement', //
    name: '职业价值观测评',
    component: ProfessionalMeasurement
  },
  {
    path: '/measurement_list', //
    name: '测评列表',
    component: MeasurementList
  },
  {
    path: '/ceping47_report', //
    name: '自我分化',
    component: Ceping47Report
  },
  {
    path: '/ceping47', //
    name: '自我分化问答',
    component: Ceping47
  },
  {
    path: '/ceping51_report', //
    name: '霍兰德报告',
    component: Ceping51Report
  },
  {
    path: '/ceping51', //
    name: '霍兰德',
    component: Ceping51
  },
  {
    path: '/ceping54_report', //
    name: '从减肥看灵魂动物测评报告',
    component: Ceping54Report
  },
  {
    path: '/ceping54', //
    name: '从减肥看灵魂动物测评',
    component: Ceping54
  },
  {
    path: '/ceping56', //
    name: '产品经理胜任能力测评',
    component: Ceping56
  },
  {
    path: '/ceping57', //
    name: '产品经理胜任能力自测',
    component: Ceping57
  },
  {
    path: '/ceping57_report', //
    name: '产品经理胜任能力自测报告',
    component: Ceping57Report
  },
  {
    path: '/ceping55_details', //
    name: '生涯信念测评',
    component: Ceping55Details
  },
  {
    path: '/ceping55', //
    name: '生涯信念测评',
    component: Ceping55
  },
  {
    path: '/ceping55_report', //
    name: '生涯信念测评',
    component: Ceping55Report
  },
  {
    path: '/ceping59', //
    name: '能力热力图测评',
    component: Ceping59
  },
  {
    path: '/ceping59_report', //
    name: '能力热力图测评',
    component: Ceping59Report
  },
  {
    path: '/ceping61', //
    name: '霍兰德测评',
    component: Ceping61
  },
  {
    path: '/ceping61_report', //
    name: '霍兰德测评',
    component: Ceping61Report
  },
  {
    path: '/ceping62_details', //
    name: '工作家庭平衡状态测评',
    component: Ceping62Details
  },
  {
    path: '/ceping62', //
    name: '工作家庭平衡状态测评',
    component: Ceping62
  },
  {
    path: '/ceping62_report', //
    name: '工作家庭平衡状态测评',
    component: Ceping62Report
  },
  {
    path: '/ceping63', //
    name: '职业价值观测评',
    component: Ceping63
  },
  {
    path: '/ceping63_report', //
    name: '职业价值观测评',
    component: Ceping63Report
  },
  {
    path: '/ceping64', //
    name: '价值观测评',
    component: Ceping64
  },
  {
    path: '/ceping64_report', //
    name: '价值观测评报告',
    component: Ceping64Report
  },
  {
    path: '/ceping110', //
    name: '价值观测评',
    component: Ceping110
  },
  {
    path: '/ceping110_report', //
    name: '价值观测评报告',
    component: Ceping110Report
  },
  {
    path: '/ceping65', //
    name: '能力热力图测评',
    component: Ceping65
  },
  {
    path: '/ceping65_report', //
    name: '能力热力图测评',
    component: Ceping65Report
  },
  {
    path: '/ceping112', //
    name: '能力热力图测评',
    component: Ceping112
  },
  {
    path: '/ceping112_report', //
    name: '能力热力图测评',
    component: Ceping112Report
  },
  {
    path: '/ceping67', //
    name: '职业定向测评',
    component: Ceping67
  },
  {
    path: '/ceping67_report', //
    name: '职业定向测评报告',
    component: Ceping67Report
  },
  {
    path: '/ceping111', //
    name: '职业定向测评',
    component: Ceping111
  },
  {
    path: '/ceping111_report', //
    name: '职业定向测评报告',
    component: Ceping111Report
  },
  {
    path: '/ceping95', //
    name: '职业定向测评',
    component: Ceping95
  },
  {
    path: '/ceping95_report', //
    name: '职业定向测评报告',
    component: Ceping95Report
  },
  {
    path: '/ceping', //
    name: '测评模板',
    component: Ceping
  },
  {
    path: '/ceping_report', //
    name: '测评报告模板',
    component: CepingReport
  },
  {
    path: '/ext_ceping', //
    name: '测评模板',
    component: ExtCeping
  },
  {
    path: '/ext_ceping_report', //
    name: '测评报告模板',
    component: ExtCepingReport
  },
  {
    path: '/drawing', //
    name: '测评画图',
    component: Drawing
  },
  {
    path: '/professional_report', //
    name: '职业价值观测评',
    component: ProfessionalReport
  },
  {
    path: '/evaluation',
    name: '邀请他评',
    component: Evaluation
  },
  {
    path: '/evaluation_name',
    name: '他评',
    component: Evaluation_Name
  },
  {
    path: '/evaluation_share',
    name: '完成他评',
    component: Evaluation_Share
  },
  {
    path: '/my_work_ability_details', //
    name: '职场可迁移能力报告（自评版）',
    component: myWorkAbilityDetails
  },
  {
    path: '/my_work_ability_details_p1', //
    name: '职场可迁移能力报告（自评版）',
    component: myWorkAbilityDetailsP1
  },
  {
    path: '/an_questions2', //
    name: '答题说明',
    component: AnswerQuestions2
  },
  {
    path: '/an_questions111', //
    name: '答题说明',
    component: AnswerQuestions111
  },
  {
    path: '/an_questions3', //
    name: '答题说明',
    component: AnswerQuestions3
  },
  {
    path: '/an_questions4', //
    name: '答题说明',
    component: AnswerQuestions4
  },
  {
    path: '/ceping68', //
    name: '加载中',
    component: Ceping68
  },
  {
    path: '/ceping68_report', //
    name: '加载中',
    component: Ceping68Report
  },
  {
    path: '/xuandui65', //
    name: '加载中',
    component: XuanDui65
  },
  {
    path: '/xuandui65_report', //
    name: '加载中',
    component: XuanDui65Report
  },
  {
    path: '/test65', //
    name: '加载中',
    component: Test65
  },
  {
    path: '/test65_report', //
    name: '加载中',
    component: Test65Report
  },
  {
    path: '/acca65', //
    name: '加载中',
    component: Acca65
  },
  {
    path: '/acca65_report', //
    name: '加载中',
    component: Acca65Report
  },
  {
    path: '/ceping69', //
    name: '加载中',
    component: Ceping69
  },
  {
    path: '/ceping69_report', //
    name: '加载中',
    component: Ceping69Report
  },
  {
    path: '/ceping70', //
    name: '加载中',
    component: Ceping70
  },
  {
    path: '/ceping70_report', //
    name: '加载中',
    component: Ceping70Report
  },
  {
    path: '/ceping70_details', //
    name: '加载中',
    component: Ceping70Details
  },
  {
    path: '/bd_ceping64', //
    name: '价值观测评',
    component: BdCeping64
  },
  {
    path: '/bd_ceping64_report', //
    name: '价值观测评报告',
    component: BdCeping64Report
  },
  {
    path: '/bd_ceping65', //
    name: '能力热力图测评',
    component: BdCeping65
  },
  {
    path: '/bd_ceping65_report', //
    name: '能力热力图测评',
    component: BdCeping65Report
  },
  {
    path: '/bd_ceping67', //
    name: '职业定向测评',
    component: BdCeping67
  },
  {
    path: '/bd_ceping67_report', //
    name: '职业定向测评报告',
    component: BdCeping67Report
  },
  {
    path: '/ceping71', //
    name: '加载中',
    component: Ceping71
  },
  {
    path: '/ceping71_details', //
    name: '加载中',
    component: Ceping71Details
  },
  {
    path: '/ceping71_report', //
    name: '加载中',
    component: Ceping71Report
  },
  {
    path: '/ceping105', //
    name: '加载中',
    component: Ceping105
  },
  {
    path: '/ceping105_details', //
    name: '加载中',
    component: Ceping105Details
  },
  {
    path: '/ceping105_report', //
    name: '加载中',
    component: Ceping105Report
  },
  {
    path: '/ceping96', //
    name: '加载中',
    component: Ceping96
  },
  {
    path: '/ceping96_details', //
    name: '加载中',
    component: Ceping96Details
  },
  {
    path: '/ceping96_report', //
    name: '加载中',
    component: Ceping96Report
  },
  {
    path: '/ceping72', //
    name: '生涯定位测评',
    component: Ceping72
  },
  {
    path: '/ceping72_report', //
    name: '生涯定位测评报告',
    component: Ceping72Report
  },
  {
    path: '/ceping72_evaluation', //
    name: '生涯定位测评报告',
    component: Ceping72Evaluation
  },
  {
    path: '/ceping73', //
    name: '加载中',
    component: Ceping73
  },
  {
    path: '/ceping73_report', //
    name: '加载中',
    component: Ceping73Report
  },
  {
    path: '/ceping73_details', //
    name: '加载中',
    component: Ceping73Details
  },
  {
    path: '/ceping98', //
    name: '加载中',
    component: Ceping98
  },
  {
    path: '/ceping98_report', //
    name: '加载中',
    component: Ceping98Report
  },
  {
    path: '/ceping98_details', //
    name: '加载中',
    component: Ceping98Details
  },
  {
    path: '/ceping99', //
    name: '加载中',
    component: Ceping99
  },
  {
    path: '/ceping99_report', //
    name: '加载中',
    component: Ceping99Report
  },
  {
    path: '/ceping99_details', //
    name: '加载中',
    component: Ceping99Details
  },
  {
    path: '/ceping47_details', //
    name: '加载中',
    component: Ceping47Details
  },
  {
    path: '/measurement_public_details', //
    name: '加载中',
    component: measurementPublicDetails
  },
  {
    path: '/measurement_public_p1_details', //
    name: '加载中',
    component: measurementPublicP1Details
  },{
    path: '/ceping54_details', //
    name: '加载中',
    component: Ceping54Details
  },
  {
    path: '/ceping74_report', //
    name: '从减肥看灵魂动物测评报告',
    component: Ceping74Report
  },
  {
    path: '/ceping74', //
    name: '从减肥看灵魂动物测评',
    component: Ceping74
  },{
    path: '/ceping74_details', //
    name: '加载中',
    component: Ceping74Details
  }, 
  {
    path: '/ceping75', //
    name: '加载中',
    component: Ceping75
  },
  {
    path: '/ceping75_report', //
    name: '加载中',
    component: Ceping75Report
  },
  {
    path: '/bd_ceping69', //
    name: '加载中',
    component: BdCeping69
  },
  {
    path: '/bd_ceping69_report', //
    name: '加载中',
    component: BdCeping69Report
  },
  {
    path: '/ceping76_report', //
    name: '加载中',
    component: Ceping76Report
  },
  {
    path: '/ceping76', //
    name: '加载中',
    component: Ceping76
  },{
    path: '/ceping76_details', //
    name: '加载中',
    component: Ceping76Details
  },
  {
    path: '/zycp', //
    name: '加载中',
    component: Zycp
  },
  {
    path: '/zycp_report', //
    name: '加载中',
    component: ZycpReport
  },
  {
    path: '/test71', //
    name: '加载中',
    component: Test71
  },
  {
    path: '/test71_details', //
    name: '加载中',
    component: Test71Details
  },
  {
    path: '/test71_report', //
    name: '加载中',
    component: Test71Report
  },
  {
    path: '/test52', //
    name: '加载中',
    component: Test52
  },
  {
    path: '/test52_report', //
    name: '加载中',
    component: Test52Report
  },
  {
    path: '/test52_details', //
    name: '加载中',
    component: Test52Details
  },
  {
    path: '/test73', //
    name: '加载中',
    component: Test73
  },
  {
    path: '/test73_report', //
    name: '加载中',
    component: Test73Report
  },
  {
    path: '/test73_details', //
    name: '加载中',
    component: Test73Details
  },
  {
    path: '/ceping78', //
    name: '加载中',
    component: Ceping78
  },
  {
    path: '/ceping78_report', //
    name: '加载中',
    component: Ceping78Report
  },
  {
    path: '/ceping78_details', //
    name: '加载中',
    component: Ceping78Details
  },
  {
    path: '/ceping84', //
    name: '加载中',
    component: Ceping84
  },
  {
    path: '/ceping84_report', //
    name: '加载中',
    component: Ceping84Report
  },
  {
    path: '/ceping84_details', //
    name: '加载中',
    component: Ceping84Details
  },
  {
    path: '/ceping97', //
    name: '加载中',
    component: Ceping97
  },
  {
    path: '/ceping97_report', //
    name: '加载中',
    component: Ceping97Report
  },
  {
    path: '/ceping97_details', //
    name: '加载中',
    component: Ceping97Details
  },
  {
    path: '/ceping85', //
    name: '加载中',
    component: Ceping85
  },
  {
    path: '/ceping85_report', //
    name: '加载中',
    component: Ceping85Report
  },
  {
    path: '/ceping85_details', //
    name: '加载中',
    component: Ceping85Details
  },
  {
    path: '/ceping86', //
    name: '加载中',
    component: Ceping86
  },
  {
    path: '/ceping86_report', //
    name: '加载中',
    component: Ceping86Report
  },
  {
    path: '/ceping86_details', //
    name: '加载中',
    component: Ceping86Details
  },

  {
    path: '/ceping106', //
    name: '加载中',
    component: Ceping106
  },
  {
    path: '/ceping106_report', //
    name: '加载中',
    component: Ceping106Report
  },
  {
    path: '/ceping106_details', //
    name: '加载中',
    component: Ceping106Details
  },

  {
    path: '/ceping107', //
    name: '加载中',
    component: Ceping107
  },
  {
    path: '/ceping107_report', //
    name: '加载中',
    component: Ceping107Report
  },
  {
    path: '/ceping107_details', //
    name: '加载中',
    component: Ceping107Details
  },
  {
    path: '/ceping108', //
    name: '加载中',
    component: Ceping108
  },
  {
    path: '/ceping108_report', //
    name: '加载中',
    component: Ceping108Report
  },
  {
    path: '/ceping108_details', //
    name: '加载中',
    component: Ceping108Details
  },
  {
    path: '/ceping109', //
    name: '加载中',
    component: Ceping109
  },
  {
    path: '/ceping109_report', //
    name: '加载中',
    component: Ceping109Report
  },
  {
    path: '/ceping109_details', //
    name: '加载中',
    component: Ceping109Details
  },


  {
    path: '/ceping87', //
    name: '加载中',
    component: Ceping87
  },
  {
    path: '/ceping87_report', //
    name: '加载中',
    component: Ceping87Report
  },
  {
    path: '/ceping87_details', //
    name: '加载中',
    component: Ceping87Details
  },
  {
    path: '/ceping88', //
    name: '加载中',
    component: Ceping88
  },
  {
    path: '/ceping88_report', //
    name: '加载中',
    component: Ceping88Report
  },
  {
    path: '/ceping88_details', //
    name: '加载中',
    component: Ceping88Details
  },
  {
    path: '/ceping89', //
    name: '加载中',
    component: Ceping89
  },
  {
    path: '/ceping89_report', //
    name: '加载中',
    component: Ceping89Report
  },
  {
    path: '/ceping89_details', //
    name: '加载中',
    component: Ceping89Details
  },
  
  {
    path: '/ceping90', //
    name: '加载中',
    component: Ceping90
  },
  {
    path: '/ceping90_report', //
    name: '加载中',
    component: Ceping90Report
  },
  {
    path: '/ceping90_details', //
    name: '加载中',
    component: Ceping90Details
  },
  
  {
    path: '/ceping91', //
    name: '加载中',
    component: Ceping91
  },
  {
    path: '/ceping91_report', //
    name: '加载中',
    component: Ceping91Report
  },
  {
    path: '/ceping91_details', //
    name: '加载中',
    component: Ceping91Details
  },
  
  {
    path: '/ceping92', //
    name: '加载中',
    component: Ceping92
  },
  {
    path: '/ceping92_report', //
    name: '加载中',
    component: Ceping92Report
  },
  {
    path: '/ceping92_details', //
    name: '加载中',
    component: Ceping92Details
  },
  
  {
    path: '/ceping93', //
    name: '加载中',
    component: Ceping93
  },
  {
    path: '/ceping93_report', //
    name: '加载中',
    component: Ceping93Report
  },
  {
    path: '/ceping93_details', //
    name: '加载中',
    component: Ceping93Details
  },
  
  {
    path: '/ceping94', //
    name: '加载中',
    component: Ceping94
  },
  {
    path: '/ceping94_report', //
    name: '加载中',
    component: Ceping94Report
  },
  {
    path: '/ceping94_details', //
    name: '加载中',
    component: Ceping94Details
  },
  {
    path: '/ceping79',
    name: '加载中',
    component: Ceping79
  },
  {
    path: '/ceping79_report',
    name: '加载中',
    component: Ceping79Report
  },
  {
    path: '/ceping79_details', //
    name: '你是哪种购物星人',
    component: Ceping79Details
  },
  {
    path: '/sale_ceping73', //
    name: '加载中',
    component: SaleCeping73
  },
  {
    path: '/sale_ceping73_report', //
    name: '加载中',
    component: SaleCeping73Report
  },
  {
    path: '/sale_ceping73_details', //
    name: '加载中',
    component: SaleCeping73Details
  },
  {
    path: '/ceping46', //
    name: '加载中',
    component: Ceping46
  },
  {
    path: '/ceping46_report', //
    name: '加载中',
    component: Ceping46Report
  },
  {
    path: '/ceping46_details', //
    name: '加载中',
    component: Ceping46Details
  },
  {
    path: '/ceping80', //
    name: '加载中',
    component: Ceping80
  },
  {
    path: '/ceping80_activity_rules', //
    name: '加载中',
    component: Ceping80ActivityRules
  },
  {
    path: '/ceping80_report', //
    name: '加载中',
    component: Ceping80Report
  },
  {
    path: '/ceping80_follow', //
    name: '加载中',
    component: ceping80Follow
  },
  {
    path: '/ceping80_clover', //
    name: '加载中',
    component: ceping80Clover
  },
  {
    path: '/ceping81', //
    name: '加载中',
    component: Ceping81
  },
  {
    path: '/ceping81_rank', //
    name: '加载中',
    component: Ceping81Rank
  },
  {
    path: '/ceping81_poster', //
    name: '加载中',
    component: Ceping81Poster
  },
  {
    path: '/ceping82', //
    name: '加载中',
    component: Ceping82
  },
  {
    path: '/ceping82_call', //
    name: '加载中',
    component: Ceping82Call
  },
  {
    path: '/ceping82_blessing', //
    name: '加载中',
    component: Ceping82Blessing
  },
  {
    path: '/ceping82_question', //
    name: '加载中',
    component: Ceping82question
  },
  {
    path: '/ceping82_bookList', //
    name: '加载中',
    component: ceping82BookList
  },
  {
    path: '/ceping82_mail', //
    name: '加载中',
    component: ceping82Mail
  },
  {
    path: '/ceping83', //
    name: '加载中',
    component: Ceping83
  },
  {
    path: '/ceping83_details', //
    name: '加载中',
    component: Ceping83Details
  },
  {
    path: '/ceping83_report', //
    name: '加载中',
    component: Ceping83Report
  },
  {
    path: '/ceping100', //
    name: '价值观测评',
    component: Ceping100
  },
  {
    path: '/ceping100_report', //
    name: '价值观测评报告',
    component: Ceping100Report
  },
  {
    path: '/ceping101', //
    name: '能力热力图测评',
    component: Ceping101
  },
  {
    path: '/ceping101_report', //
    name: '能力热力图测评',
    component: Ceping101Report
  },
  {
    path: '/ceping103', //
    name: '职业定向测评',
    component: Ceping103
  },
  {
    path: '/ceping103_report', //
    name: '职业定向测评报告',
    component: Ceping103Report
  },
  {
    path: '/ceping104', //
    name: '加载中',
    component: Ceping104
  },
  {
    path: '/ceping104_report', //
    name: '加载中',
    component: Ceping104Report
  },
  {
    path: '/ceping113', //
    name: '加载中',
    component: Ceping113
  },
  {
    path: '/ceping113_report', //
    name: '加载中',
    component: Ceping113Report
  },
  {
    path: '/ceping114', //
    name: '加载中',
    component: Ceping114
  },
  {
    path: '/ceping114_report', //
    name: '加载中',
    component: Ceping114Report
  },
]
